<form class="form-horizontal" (ngSubmit)="submit()" #thisForm="ngForm">
  <app-dados-boleta
    titulo="Dados da Boleta Renda Variável"
    [operationDate]="model.operationDate"
    [id]="model.id"
    [accountManagerName]="model.accountManagerName"
    [accountManagerDocument]="model.accountManagerDocument"
    [statusDescription]="model.statusDescription"
  >
  </app-dados-boleta>

  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados da Carteira</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-4">
          <label>Conta B3 - Código</label>
          <input
            type="text"
            class="form-control"
            name="b3Account"
            [(ngModel)]="model.clientCode"
            pattern="\d+-?\d*"
            maxlength="15"
            data-cy="b3Account"
            disabled
          />
        </div>
        <div class="col-2">
          <label>Conta B3 - Dígito</label>
          <input
            type="text"
            class="form-control"
            name="b3AccountDigit"
            [(ngModel)]="model.clientCodeDigit"
            pattern="\d+-?\d*"
            maxlength="1"
            data-cy="b3AccountDigit"
            disabled
          />
        </div>
        <div class="col-6">
          <label>Data B3</label>
          <input
            type="text"
            class="form-control"
            name="stockExchangeDate"
            [(ngModel)]="model.stockExchangeDate"
            [textMask]="{ mask: validator.dateMask, guide: false }"
            data-cy="stockExchangeDate"
            disabled
          />
        </div>
      </div>
    </div>
  </div>

  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados da Operação</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-3">
          <label>Código da Corretora</label>
          <input
            type="text"
            class="form-control"
            name="brokerCode"
            [(ngModel)]="model.brokerCode"
            pattern="\d+-?\d*"
            maxlength="10"
            disabled
          />
        </div>
        <div class="col-3">
          <label>Total Compra</label>
          <input
            type="text"
            class="form-control"
            name="buyTotal"
            value="{{ model.buyTotal | currency: 'R$':'symbol':'1.2-2' }}"
            disabled
          />
        </div>
        <div class="col-3">
          <label>Total Venda</label>
          <input
            type="text"
            class="form-control"
            name="sellTotal"
            value="{{ model.sellTotal | currency: 'R$':'symbol':'1.2-2' }}"
            disabled
          />
        </div>
        <div class="col-3">
          <label>Total Operação</label>
          <input
            type="text"
            class="form-control"
            name="operationTotal"
            value="{{
              model.sellTotal - model.buyTotal | currency: 'R$':'symbol':'1.2-2'
            }}"
            disabled
          />
        </div>
      </div>
    </div>
  </div>
  <div class="card mt-3">
    <mat-toolbar> Itens da Boleta </mat-toolbar>

    <!-- <div *ngIf="canEdit()" class="card mt-3 items-card">
      <div class="card-header text-uppercase">
        Adicionar Item
      </div>
      <form #subForm="ngForm">
        <div class="card-body">
          <div class="row mb-2">
            <div class="col-2">
              <label>Mercado</label>
              <input
                type="text"
                class="form-control"
                name="marketType"
                [(ngModel)]="newItem.marketType"
                maxlength="10"
                required
              />
            </div>

            <div class="col-3">
              <label>Título</label>
              <input
                type="text"
                class="form-control"
                name="tradingCode"
                [(ngModel)]="newItem.tradingCode"
                required
                maxlength="20"
              />
            </div>

            <div class="col-2">
              <label>Valor</label>
              <input
                type="text"
                class="form-control"
                name="price"
                [(ngModel)]="newItem.price"
                [textMask]="{ mask: validator.unitPriceMask }"
                required
              />
            </div>

            <div class="col-2">
              <label>Quantidade</label>
              <input
                type="text"
                class="form-control"
                name="amount"
                [(ngModel)]="newItem.amount"
                [textMask]="{ mask: validator.decimalIndexFeeMask }"
                required
              />
            </div>

            <div class="col-2">
              <label>Tipo</label>
              <div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    data-cy="purchase"
                    type="radio"
                    name="buySell"
                    id="buySell-1"
                    value="C"
                    [(ngModel)]="newItem.buySell"
                  />
                  <label class="form-check-label" for="buySell-1">
                    Compra
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    data-cy="sale"
                    type="radio"
                    name="buySell"
                    id="buySell-2"
                    value="V"
                    [(ngModel)]="newItem.buySell"
                  />
                  <label class="form-check-label" for="buySell-2">
                    Venda
                  </label>
                </div>
              </div>
            </div>

            <div class="col-1">
              <label></label>
              <div class="button-container">
                <button
                  type="button"
                  class="btn btn-primary add-button"
                  (click)="addItem()"
                >
                  <i class="fa fa-sm fa-plus"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div> -->

    <table #table mat-table [dataSource]="VariableIncomesItems" class="col-12">
      <ng-container matColumnDef="MarketType">
        <th mat-header-cell *matHeaderCellDef>Mercado</th>
        <td class="align-middle" mat-cell *matCellDef="let element">
          {{ element.marketType }}
        </td>
      </ng-container>

      <ng-container matColumnDef="BuySell">
        <th mat-header-cell *matHeaderCellDef>Compra / Venda</th>
        <td class="align-middle" mat-cell *matCellDef="let element">
          {{ element.buySell }}
        </td>
      </ng-container>

      <ng-container matColumnDef="Asset">
        <th mat-header-cell *matHeaderCellDef>Título</th>
        <td mat-cell *matCellDef="let element">
          {{ element.tradingCode
          }}{{ element.companyName ? " - " + element.companyName : " " }}
          {{ element.specification }}
        </td>
      </ng-container>

      <ng-container matColumnDef="Amount">
        <th mat-header-cell *matHeaderCellDef>Quantidade</th>
        <td mat-cell *matCellDef="let element">
          {{ element.amount }}
        </td>
      </ng-container>

      <ng-container matColumnDef="Price">
        <th mat-header-cell *matHeaderCellDef>Valor</th>
        <td mat-cell *matCellDef="let element">
          {{ element.price | currency: "R$":"symbol":"1.2-2" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="TotalPrice">
        <th mat-header-cell *matHeaderCellDef>Total</th>
        <td mat-cell *matCellDef="let element">
          {{ element.amount * element.price | currency: "R$":"symbol":"1.2-2" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="Actions">
        <th mat-header-cell *matHeaderCellDef [hidden]="true"></th>
        <td
          mat-cell
          *matCellDef="let element; let i = index"
          class="actions"
          [hidden]="true"
        >
          <div>
            <a (click)="removeItem(element, i)">
              <i class="fa fa-lg fa-minus-square"></i>
            </a>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns"></tr>
    </table>

    <paginador
      *ngIf="isEditing"
      [listedPages]="listedPages"
      [firstItemOnPage]="firstItemOnPage"
      [lastItemOnPage]="lastItemOnPage"
      [totalPages]="totalPages"
      [totalItems]="totalItems"
      [itemsPerPage]="[10, 25, 50, 100]"
      [currentPage]="currentPage"
      (onSearch)="getVariableIncomeListItem($event[0], $event[1])"
    ></paginador>
  </div>

  <br />

  <div class="actions" *ngIf="canEdit()">
    <input
      *ngIf="false"
      type="button"
      data-cy="submit"
      value="Salvar"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="submit()"
      [debounceTime]="200"
    />
    <input
      type="button"
      data-cy="forward"
      value="Encaminhar"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="forward()"
      [debounceTime]="200"
    />
  </div>

  <div class="actions" *ngIf="canChangeStatus()">
    <input
      type="button"
      value="Aprovar"
      data-cy="approve"
      class="btn btn-success me-2"
      appDebounceClick
      (debounceClick)="approve()"
      [debounceTime]="200"
    />
    <input
      type="button"
      value="Reprovar"
      data-cy="reject"
      class="btn btn-danger me-2"
      appDebounceClick
      (debounceClick)="reject()"
      [debounceTime]="200"
    />
  </div>

  <div class="actions" *ngIf="false">
    <input
      type="button"
      value="Duplicar"
      data-cy="duplicate"
      class="btn btn-primary me-2"
      [disabled]="!model.id"
      appDebounceClick
      (debounceClick)="duplicate()"
      [debounceTime]="200"
    />
  </div>
</form>

<br />

<app-workflow-history
  [hideDraftStatus]="true"
  [ticketId]="model.id"
  [refresh]="dataChanged"
></app-workflow-history>
